import { render } from "./DoctorsIndex.vue?vue&type=template&id=55506ca0&scoped=true"
import script from "./DoctorsIndex.vue?vue&type=script&lang=js"
export * from "./DoctorsIndex.vue?vue&type=script&lang=js"

import "./DoctorsIndex.vue?vue&type=style&index=0&id=55506ca0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55506ca0"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtnToggle,QInput,QIcon,QBtn,QBanner,QTable,QTd,QMenu,QList,QItem,QItemSection,QBtnGroup});qInstall(script, 'directives', {ClosePopup});
